import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrCode({ value }: { value: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      const url = await QRCode.toDataURL(value, { width: 320, margin: 1 });
      if (!cancelled) setDataUrl(url);
    }
    if (value) run();
    return () => {
      cancelled = true;
    };
  }, [value]);

  if (!dataUrl) return <div className="h-[320px] w-[320px] rounded-xl bg-white/5" />;
  return <img src={dataUrl} className="h-[320px] w-[320px] rounded-xl bg-white p-3" alt="QR code" />;
}

